export const forbiddenExtensions = [
  "rvt",
  "3ds",
  "dwg",
  "dwf",
  "dwfx",
  "f3d",
  "ifc",
  "max",
  "maxc",
  "nwd",
  "obj",
  "bin",
  "bim",
  "3dxml",
  "3mf",
  "acp",
  "amf",
  "aec",
  "ar",
  "art",
  "asc",
  "asm",
  "brep",
  "c3d",
  "c3p",
  "ccc",
  "ccm",
  "ccs",
  "cad",
  "catdrawing",
  "catpart",
  "catproduct",
  "catprocess",
  "cgr",
  "ckd",
  "ckt",
  "co",
  "drw",
  "dft",
  "dgn",
  "dgk",
  "dmt",
  "dxf",
  "dwb",
  "easm",
  "edrw",
  "emb",
  "eprt",
  "escpcb",
  "escsch",
  "esw",
  "excellon",
  "exp",
  "fcstd",
  "fm",
  "fmz",
  "g",
  "gbr",
  "glm",
  "grb",
  "gri",
  "gro",
  "iam",
  "icd",
  "idw",
  "iges",
  "intergraph",
  "io",
  "ipn",
  "ipt",
  "jt",
  "mcd",
  "mdg",
  "model",
  "ocd",
  "par",
  "pipe",
  "pln",
  "prt",
  "psm",
  "psmodel",
  "pwi",
  "pyt",
  "skp",
  "rlf",
  "rvm",
  "rfa",
  "rxf",
  "s12",
  "scad",
  "scdoc",
  "sldasm",
  "slddrw",
  "sldprt",
  "dotxsi",
  "step",
  "stl",
  "std",
  "tct",
  "tcw",
  "unv",
  "vc6",
  "vlm",
  "vs",
  "wrl",
  "x_b",
  "x_t",
  "xe",
  "zofzproj",
  "3dmf",
  "3dm",
  "abc",
  "ac",
  "an8",
  "aoi",
  "b3d",
  "blend",
  "block",
  "bmd3",
  "bdl4",
  "brres",
  "bfres",
  "c4d",
  "cal3d",
  "ccp4",
  "cfl",
  "cob",
  "core3d",
  "ctm",
  "dae",
  "dff",
  "dpm",
  "dts",
  "egg",
  "fact",
  "fbx",
  "glb",
  "gltf",
  "iob",
  "jas",
  "jmesh",
  "ldr",
  "lwo",
  "lws",
  "lxf",
  "lxo",
  "m3d",
  "ma",
  "mb",
  "mpd",
  "md2",
  "md3",
  "md5",
  "mdx",
  "mesh",
  "mm3d",
  "mpo",
  "mrc",
  "nif",
  "off",
  "ogex",
  "ply",
  "prc",
  "pov",
  "r3d",
  "rwx",
  "sia",
  "sib",
  "smd",
  "u3d",
  "usd",
  "usda",
  "usdc",
  "usdz",
  "vim",
  "vrml97",
  "vue",
  "vwx",
  "wings",
  "w3d",
  "x",
  "x3d",
  "z3d",
  "zbmx",
];
